import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Field, reduxForm, change } from 'redux-form';
import { connect } from "react-redux"
import classNames from 'classnames';

import agent from '../agent'
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import Back from "../components/Back"

import ethnicities from '../data/ethnicities';

import Roles from '../components/Roles'
import Statistics from '../components/Statistics'
import Questions from '../components/Questions'
import Availability from '../components/Availability'
import Confirmation from '../components/Confirmation'
import CheckinSuccess from '../components/CheckinSuccess'

const Header = (props) => {
	const {clientDetails, artist, artistInfo, checkin, success} = props
	if (clientDetails && clientDetails.projectId) {
		return (
			<section id="brand-logo" className="section-brand-logo checkin-header section">
			  <div className="row text-center">
				  <div className="small-12 medium-4 medium-offset-4 column">
				  	<div className="header-image-container">
					  	<img className="project-logo" src={clientDetails.projectId.cover_url} alt="" />
				  	</div>
				  </div>
				  <div className="small-12 medium-4 column">
				  	<div className="header-image-container">
					  	<img className="company-logo" src={clientDetails.client.logo_url} alt="" />
				  	</div>
				  </div>
				</div>

			  <div className="row">
				  <div className="small-12 small-centered column text-center post-relative">
				  	<Back />
				  	<div className="post-relative artist-info">
					  	<img className="small-artist-photo" src={artist.photo_thumb} alt=""/>
					  	<h2 className="name text-uppercase">{artist.first_name}</h2>
					    <p className="top-title">Let's now cover the essentials to get you checked-in</p>
				    </div>
				  </div>
			  </div>
			</section>
		)
	}
	return (
		<section id="brand-logo" className="section-brand-logo section">
		  <div className="row">
		  <div className="small-12 small-centered column text-center">

		  	<div className="header-image-container">
		  	{
		  		checkin && checkin.companies
		  		? <img className="company-logo" src={props.checkin.companies[0].logo_url} alt="" />
		  		: <img className="am-logo" src={AMLogo} alt=""/>
						// props.checkin.companies[0].logo_url
						// props.checkin.project.cover_url
		  	}
		  	</div>
		  	{ artistInfo && <h2 className="name">{artistInfo.first_name}</h2>}

				<div className="header-image-container">
					{ checkin && <img src={checkin.project.cover_url} alt=""/> }
				</div>
		    <p className="top-title">Please follow steps below to submit yourself</p>
		  </div>
		  </div>
		</section>
	)
}

const Logout = (props) => (	
	props.appLoaded && props.clientToken
	?	<span className="logout-btn fa-stack fa-1x" onClick={props.onClickLogout} >
		  <i className="fa fa-circle fa-stack-2x icon-background"></i>
		  <i className="fa fa-sign-out fa-stack-1x"></i>
		</span>
  : ''
)

class ProjectCheckinContainer extends Component {
 	state = {
 		roles: [],
 		defaultPage: 'statistics',
 		wizardSteps: ['statistics', 'questions', 'availability', 'confirmation'],
 		currentPage: 'statistics',
 		exceptedpage: ['statistics', 'confirmation'],	//first and last steps
		dummypage: 'questions'	//second steps
 	}

 	componentWillReceiveProps(nextProps) {
 		// if (nextProps.checkinSuccess) {
 		// 	const { location } = this.props;
 		// 	// console.log('sample');
 		// 	this.props.history.push({
			//   pathname: '/checkin/success',
			//   state: location.state
			// })
 		// }
	}

	componentWillUnmount() {
		this.props.onUnmount()
		console.log('>>>unmounting')
	}

  componentDidMount() {
  	const { location, match, artistInfo } = this.props
  	const artistId = artistInfo ? artistInfo.id : location.state.artist.id
  	this.props.getProjectArtist(match.params.id, artistId);
  	// this.props.getQuestions(match.params.id);
  	// 
  	console.log('here->checkin', location)
  	if (location.state && location.state.projectDetails && !location.state.hasAudition) {
  		this.setState({
  			defaultPage: 'roles',
  			currentPage: 'roles',
  			wizardSteps: this.state.wizardSteps.unshift('roles') && this.state.wizardSteps
  		})
  	}

  }

  nextPage = () => {
  	const { wizardSteps, currentPage } = this.state

		this.setState({
			currentPage: wizardSteps[wizardSteps.indexOf(currentPage) + 1],
			dummypage: wizardSteps.indexOf(currentPage) >= 1 ? '--' : 'statistics'
		})
	}

	previousPage = () => {
		const { wizardSteps, currentPage } = this.state
		this.setState({
			currentPage: wizardSteps[wizardSteps.indexOf(currentPage) - 1],
			dummypage: wizardSteps.indexOf(currentPage) >= 1 ? '--' : 'statistics'
		})
	}

	submit = values => {
		console.log('>>CheckinForm', values);
		const { match, artistInfo, location } = this.props;

		const toUnderscore = name => {
			return name.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
		};

		let artist_payload = {
			project_id: match.params.id,
			artist_id: artistInfo ? artistInfo.id : location.state.artist.id,
			signature_image: values.signature || '',
			statistics_region: values.statistics_region,
			measurement_sizing: values.measurement_sizing,
			statistics_unit: values.statistics_unit,
		}

		if (values.roles && values.roles.length) {
				artist_payload.roles = values.roles
		}

		let statistics = {};
		let questions_answers = {
			job: [],
			availability: []
		};

		for (let [key] of Object.entries(values)) {
			if (key === 'availability' || key === 'questions') {
				for (let [key_1, val_1] of Object.entries(values[key])) {
				  	const k = key_1.replace('_', '');
				  	let obj = {};
				  	obj.question_id = k;
				  	obj.answer = val_1;

				  	if (key === 'questions') {
				  		questions_answers.job.push(obj);
				  	}

				  	if (key === 'availability') {
				  		questions_answers.availability.push(obj);
				  	}
				}
			}


			if (key === 'statistics') {
				for (let [key_2, val_2] of Object.entries(values[key])) {
				  	const k = toUnderscore(key_2);

				  	if (k === 'ethnicities') {
							val_2 = val_2.map(item => item.id)
							val_2 = val_2.join(',')
						}

				    statistics[k] = val_2;
				}
			}
		}

		artist_payload.stats_region = 'US';
		artist_payload.statistics = JSON.stringify(statistics);
		artist_payload.questions_answers = JSON.stringify(questions_answers);
		// console.log(artist_payload)
    return this.props.submitCheckin(artist_payload)
	}

	render() {
		const { page, wizardSteps, currentPage, defaultPage, exceptedpage, dummypage  } = this.state
		const { checkin, checkinSuccess, errors, location, message } = this.props

		console.log('render->checkin', checkin)

		if (checkinSuccess) {
			return (
				<div className="checkin-success">
				<Header {...this.props.location.state} checkin={checkin} artistInfo={this.props.artistInfo} success="true"/>

				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					<div className="text-center white-text">
						<h3>Success!</h3>
						<h5 className="loading-text">
						Thank you {this.props.artistInfo ? this.props.artistInfo.first_name : this.props.location.state.artist.first_name}, you have successfully checked-in, you are ready to audition, good luck!
						</h5>
					</div>

					</div>
					</div>
				</section>

				<section className="section">
					<div className="grid-x align-center">
						<div className="small-6 cell text-center">
							{
								location.state && location.state.clientDetails
									? <Link 
										  className="button primary"
											to={{
												pathname:`/artist/login`, 
												search: `?project=${location.state.clientDetails.projectId.id}`,
												state: location.state.clientDetails }}>
											Please click here
										</Link>
									: <Link className="button primary next" to="/artist/login">Please click here</Link>
							}
						</div>
					</div>
				</section>
				</div>
			)
		}
		
		if (!checkin) {
			return (
				<div id="project-checkin-container">
					<Header {...this.props.location.state} />
					<section className="gray-bg section">
						<p className="text-center loading-text">Loading Checkin Form...</p>
					</section>
				</div>
				
			)
		}

		return (
			<div id="project-checkin-container">
				<Header {...this.props.location.state} checkin={checkin} artistInfo={this.props.artistInfo}/>
				<Logout {...this.props} />
					
				<section id="artist-essentials" className="section-artist-essentials gray-bg">
					<div className="grid-x align-center text-center">
						<div className="small cell small-10 medium-10 large-8 cell">
							<ul className="tabs menu steps expanded checkin" data-tabs>
							{								
								wizardSteps.map((currentStep, index) => 
									<li key={index + 1} className={
										classNames("tabs-title", {'columnli':  true},
											{'hideli' : (wizardSteps.indexOf(currentStep) !== wizardSteps.indexOf(currentPage)) && exceptedpage.indexOf(currentStep) === -1},
											{'showli' : (wizardSteps.indexOf(currentStep) === wizardSteps.indexOf(currentPage)) || (currentStep === dummypage && currentStep !== currentPage)},
											{'is-active' : wizardSteps.indexOf(currentStep) <= wizardSteps.indexOf(currentPage) })}>
									  	<div className="step-num">{index + 1}</div>
								        <div className="step-name">{currentStep}</div>
								  </li>
								)
							}
							</ul>

						</div>
					</div>
				</section>

				<div id="checkin-form-wizard">


				{(() => {

					const wizardButtons = {
						nextPage: wizardSteps.indexOf(currentPage) !== wizardSteps.length - 1 ? true : false,
					  previousPage: wizardSteps.indexOf(currentPage) !== 0 && this.previousPage,
					  onSubmit: wizardSteps.indexOf(currentPage) === wizardSteps.length - 1 ? this.submit : this.nextPage
					}

					switch(currentPage) {
						case 'roles':
							return <Roles 
								roles={location.state.projectDetails.roles}
		      		  artist={this.props.artistInfo || this.props.location.state.artist }
		      		  aud={checkin.auditions} proj={checkin.project}
		      			{...wizardButtons} />
						case 'statistics':
							return <Statistics 
		      		  artist={this.props.artistInfo || this.props.location.state.artist }
		      		  {...wizardButtons} />
						case 'questions':
							return <Questions
		          	questions={this.props.checkin.job_questions}
		            {...wizardButtons} />
						case 'availability':
							return <Availability
		          	availability={this.props.checkin.availability_questions}
		            {...wizardButtons} />
						case 'confirmation':
							return <Confirmation
								errors={errors}
								errorMessage={this.props.errorMessage}
								location={location}
								currentState={this.props.location.state}
								checkin={checkin}
								artist={this.props.artistInfo || this.props.location.state.artist }
								setSignature={this.props.setSignature}
								flag={checkin.project.public_signature_enabled}
		            {...wizardButtons} />
					}

				})()}

				</div>

			</div>
		)
	}
}

ProjectCheckinContainer = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(ProjectCheckinContainer)

const mapStateToProps = (state, ownProps) => {
	const stats = state.common.artistInfo ? state.common.artistInfo.statistics : ownProps.location.state.artist.statistics
	const region = state.common.artistInfo ? state.common.artistInfo.country : 'US'

	const currentEthnicities = stats.ethnicities ? JSON.parse(`[${stats.ethnicities}]`) : []
	const parsedEthnicities = ethnicities.filter(item => currentEthnicities.includes(parseInt(item.id)) )


	if (stats.licenses_held) {
		delete stats.licenses_held
	}

	return ({
		...state.auth,
		...state.common,
		...state.artist,
		...state.client,
		checkin: state.artist.checkin,

		initialValues: {
			statistics_region: 'US',
			statistics_unit: 'IN',
			measurement_sizing: 'ADLT',
	    statistics: {
	      // region: region,
	      ...stats,
	      ethnicities: parsedEthnicities
	    }
	  }
	})
}

const mapDispatchToProps = (dispatch) => ({
	setSignature: sig => dispatch(change( "checkinWizard", "signature", sig)),
	getProjectArtist: (projectId, artistId) =>
		dispatch({ 
			type: 'GET_PROJECT_ARTIST', 
			payload: agent.Client.checkProjectArtist(projectId, artistId)
		}),
	getQuestions: id =>
		dispatch({ type: 'CHECKIN_QUESTIONS', payload: agent.Client.getCheckinQuestions(id) }),
	submitCheckin: payload =>
		dispatch({ type: 'SUBMIT_CHECKIN', payload: agent.Artist.checkin(payload) }),
	onClickLogout: () =>
		dispatch({ type: 'LOGOUT' }),
	onRedirect: () =>
		dispatch({ type: 'REDIRECT' }),
	onUnmount:() =>
		dispatch({ type: 'CHECKIN_UNLOADED' })
})
export default connect(mapStateToProps, mapDispatchToProps)(ProjectCheckinContainer)






// WEBPACK FOOTER //
// ./src/containers/ProjectCheckinContainer.js